import { useLocation } from 'wouter'
import { CircleAlert, House } from 'lucide-react'
import { Card, CardContent } from '../components/ui/card'
import { Button } from '../components/ui/button'

export default function NotFound() {
  const [, navigate] = useLocation()

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100">
      <Card className="w-full max-w-lg mx-4 shadow-lg border-0 bg-white/80 backdrop-blur-sm">
        <CardContent className="pt-8 pb-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-red-100 rounded-full animate-pulse" />
              <CircleAlert className="relative h-16 w-16 text-red-500" />
            </div>
          </div>
          <h1 className="text-4xl font-bold text-slate-900 mb-2">404</h1>
          <h2 className="text-xl font-semibold text-slate-700 mb-4">Página não encontrada</h2>
          <p className="text-slate-600 mb-8 leading-relaxed">
            A página que você está procurando não existe.
            <br />
            Pode ter sido movida ou removida.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button onClick={() => navigate('/')} className="bg-[#1D71C3] hover:bg-[#175FA3]">
              <House className="w-4 h-4 mr-2" />
              Voltar para o início
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}